import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingUsers = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/users`, {params});
};